module.exports = __webpack_public_path__ + "static/3-84b4fcfacfc86a826efeaa8c3c3637c6.jpg";